<script>
    import SectionHeader from '../components/SectionHeader.svelte';
    import AdminAlertReportTable from '../components/AdminAlertReportTable.svelte';
    import { fade } from 'svelte/transition';
    import { onMount } from 'svelte';
    import { showLoading } from '../components/Overlay.svelte';
    import { toast } from '../components/Toast.svelte';
    import { AppController } from '../AppController';
    import { push } from 'svelte-spa-router';

    onMount(async () => {
      try {
        showLoading(true);
        await AppController.getAlertCountsByAccount();
      } catch(e) {
        console.log(e);
        toast('danger', 4000, 'Error', 'An error occured while retrieving report.');
      } finally {
        showLoading(false);
      }
    });

    const goToAccount = (accountId) => {
      push(`/admin/account/${accountId}`);
    }
  </script>
  
  <div in:fade="{{duration: 1000}}">
    <SectionHeader section='Reports' subsection='Alert Counts'></SectionHeader>
    <AdminAlertReportTable on:goToAccount={(event) => goToAccount(event.detail)}></AdminAlertReportTable>
  </div>